export default [
	"dashboard",
	"stream rating",
	"users",
	"streamers",
	"playlist",
	"channel list",
	"logs",
	"regions",
	"admins"
];



// WEBPACK FOOTER //
// ./src/script/optionOperator.js